export const blogs = [
  {
    id: 1,
    img: "chart",
    backgroundColor: "#da8e50ab",
    link: "advertising-in-telegram",
    title: "Реклама в Телеграм",
    anotation:
      "Как грамотно вести телеграм-канал и использовать его как инструмент продвижения",
    caption:
      "Мессенджер Telegram стремительно набрала обороты и уже сейчас имеет аудиторию 50 миллионов человек. А это половина России! В 2021 были установлены рекордные показатели по объему рекламы в Телеграме и составили около 15 миллиардов рублей. Как же грамотно вести телеграм-канал и использовать его как инструмент продвижения? Рассказываем в этой статье.",
    footer:
      "Не стоит жалеть времени на то, чтобы раскрутить канал, в котором вы хотите продвигать себя. От этого зависит популярность и значимость вашего ресурса. Успехов в продвижении!",
    sections: [
      {
        title: "Личный Telegram-канал: преимущества",
        text: "Сомневаться в эффективности создания сообщества в Телеграм однозначно не стоит.  Вот несколько причин:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Возможность рекламировать и продвигать практически все!",
            text: "Да, это касается не только товаров и личного бренда. Рекламировать можно события, услуги, приложения, другие страницы мессенджера.",
          },
          {
            title: "До подписчиков доходит весь контент без исключений",
            text: "Социальная сеть не имеет папок со «спамом». Если пользователь подписан на ваш канал – он увидит все опубликованные сообщения.",
          },
          {
            title: "Универсальные помощники – боты",
            text: "Они помогают автоматизировать контент и облегчить ведение тысячного или миллионного сообщества.",
          },
        ],
      },
      {
        title: "Привлекаем новых подписчиков",
        text: "Не важно, какую цель преследует ваш канал – нужно поддерживать интерес читателей. Актуальный и регулярный контент притягивает аудиторию сам собой, но достаточно медленно. Именно поэтому важно привлекать инструменты продвижения Telegram.\n\n Перечислим основные из них:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Накрутка ботов",
            text: "Необходима для доверия аудитории. Согласитесь, никто не захочет подписываться на сообщество, в котором нет участников.",
          },
          {
            title: "Внедрение чат-ботов",
            text: " Мессенджер содержит множество инструментов для автоматизации контента различных тематик: от розыгрышей до рекламы.",
          },
          {
            title: "Рассылка",
            text: " Она может быть осуществлена в групповые чаты и/или личные сообщения.",
          },
          {
            title: "Взаимный пиар в других сообществах",
            text: "Это может быть прямое продвижение, участие в подборках или реклама за бартер. Все зависит от договоренностей с конкурентами.",
          },
          {
            title: "Привлечение аудитории из других социальных сетей",
            text: "Если у вас уже есть читатели в других медиа, то смело приглашайте их.",
          },
          {
            title:
              "Размещение статьи на сайте конкурента с гиперссылкой на ваш канал",
            text: "Обратите внимание, что текст должен иметь прежде всего информационную, а не только рекламную ценность.",
          },
          {
            title: "Попасть в телеграм-каталог",
            text: "Специальные сайты, группы или сообщества собирают полезные подборки с каналами.",
          },
          {
            title: "Авторские «плюшки»",
            text: "Это неочевидный способ продвижения, но довольно действенный. Вы можете создать креативный стикерпак с логотипом вашего канала – это точно привлечет внимание аудитории.",
          },
        ],
      },

      {
        title: "Как заработать на продаже рекламы?",
        text: "Рекламодателей в первую очередь привлекают каналы с количеством подписчиков более 1000. «Ценовая вилка» на продажу рекламных публикаций варьируется в зависимости от количества подписчиков. Соответственно, чем больше читателей – тем дороже реклама.\n\nПрайс, как правило, рассчитывается из формулы «1 рубль = 1 подписчик». Однако рекламодатели также обращают внимание не только на количество, но и на аудиторные группы. Довольно часто происходит так, что 500 человек у блогера вовлечены намного больше, чем 2000 у какого-либо бренда.",
        withImage: false,
        withList: false,
      },
      {
        title: "Продвигаем свой бизнес",
        text: "Важно, чтобы реклама на канале соответствовала потребностям аудитории. Сообщества в Telegram – это тематические площадки единомышленников, поэтому на каналах, посвященных культуре и искусстве, следует отдавать предпочтение рекламе современных арт-пространств и галерей, а не одежды и текстиля. Таким образом ваши читатели становятся потенциальными клиентами рекламируемого сервиса/бренда.",
        withImage: false,
        withList: false,
      },
      {
        title: "Раскрутка канала: с чего начать?",
        text: "Даже после накрутки подписчиков канал не становится успешным, если контент не является интересным для читателей. Удержать внимание подписчиков – важная задача и миссия, которую постоянно должен преследовать владелец сообщества. Эффективный способ привлечения новых читателей - групповая или личная рассылка.",
        withImage: false,
        withList: false,
      },
      {
        title: "В чем моя фишка?",
        text: "Читатели хотят остаться только на канале, у которого есть своя неповторимая «изюминка» и уникальность. То есть что-то, что нельзя больше нигде получить. Иногда, чтобы выработать свою фишку – нужно немного времени. И это абсолютно нормально.\n\nПеречислим некоторые «фишки»:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Экспертный спикер",
            text: "Всегда интересно и познавательно, когда канал ведет подтвержденный эксперт в своей сфере.",
          },
          {
            title: "Бизнес «за кадром»",
            text: "Рассказывать о внутренних процессах своего дела глазами сотрудников.",
          },
          {
            title: "Индивидуальный стиль публикаций",
            text: "Это может быть необычное форматирование или стилистика текста. Например, в формате заметок или личного дневника.",
          },
          {
            title: "Отраслевые или тематические публикации",
            text: "Информационные или юмористические посты на узкую тему, рассчитанные на конкретные аудиторные группы. Например, познавательный контент для музыкантов, писателей, докторов или экологов. ",
          },
        ],
      },
      {
        title: "Детальный контент-план и публикация «цепляющих» постов",
        text: "Когда на вас подписывается новый пользователей, он изучает контент с самого первого поста и решает, интересен ли он. Именно поэтому большее внимание следует уделить первым публикациям на вашем канале и внешнему виду. Помните: важны все детали!",
        withImage: false,
        withList: false,
      },
      {
        title: "Бесплатные инструменты продвижения Telegram",
        text: "В самом начале, когда на канале нет и 1000 читателей, отдается предпочтение бесплатным методам раскрутки. Однако такие способы развивают сообщества с низкой скоростью, а конверсия не компенсирует потраченное время. О некоторых из них мы уже говорили выше, раскроем их чуть подробней:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "«Сарафанное радио» в онлайн-формате",
            text: "Это может быть пост в других социальных сетях с гиперссылкой на сообщество. Текст должен не только рассказывать, но и продвигать ваш канал, рассказывать о его преимуществах.",
          },
          {
            title: "Анонс публикаций в других социальных сетях",
            text: "Этот метод дополняет первый.",
          },
          {
            title: "Репосты",
            text: "Можно попросить друзей рассказать о вашем сообществе, чтобы они пригласили в него своих читателей.",
          },
          {
            title: "Бесплатные каталоги",
            text: "Регистрация в специальных группах или на сайтах, которые собирают подборки актуальных Telegram-каналов по разделам. Популярные каталоги: Telegros, Tlgrm.",
          },
          {
            title: "Взаимная реклама у конкурентов",
            text: "Для этого необходимо найти схожие по тематике и стилю контента сообщества и договориться о сотрудничестве.",
          },
          {
            title: "Анонс в рассылке",
            text: "Если ваш бренд/продукт уже имеет групповую рассылку по почте – добавьте ненавязчивую подводку со ссылкой в очередном письме.",
          },
          {
            title: "Интерактив и креатив",
            text: "Актуальны любые формы взаимодействия с аудиторией: опросы, загадки, ребусы, квесты, конкурсы, голосования. Развитие пользовательского контента повышает вовлеченность аудитории и способствует привлечению новых читателей.",
          },
        ],
      },
      {
        title: "Платные инструменты продвижения Telegram",
        text: "Платная раскрутка контента может производится внутри самого мессенджера или с привлечением внешних сервисов. Каждый из методов имеет свои особенности.\n\nЧтобы рекламировать у конкурентов, можно направиться на специальные биржы/чаты, либо договориться о сотрудничестве напрямую с владельцем сообщества. Биржи удобнее использовать, когда необходимо продвижение сразу на нескольких каналах. При личном общении с администраторами канала, важно уметь грамотно торговаться и при возможности снижать цену, так как фиксированной ставки за публикации не бывает. Команда профессионалов Pavel&Co поможет вам правильно применить данные инструменты продвижения. Наши специалисты обращают внимание, что:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Накрутка ботов",
            text: "Действенный способ придать «веса» каналу, поднимает его в строке поиска, повышает уровень доверия читателей.",
          },
          {
            title: "Накрутка просмотров",
            text: "Накрутка просмотров показывает показывает, что аудитория вовлечена.",
          },
          {
            title: "Pассылка по групповым чатам или личным сообщениям",
            text: "один из самых эффективных способов продвижения. Собираются данные о самых активных читателях и отправляется сообщение со ссылкой на ваш ресурс.",
          },
          {
            title: "Инвайтинг",
            text: "В случае если у вас групповой чат (подробнее о том как это можно выяснить читайте в <Link to='/' className='navbar-link blog-text-link'>статье</Link>), то самым лучшим вариантом продвижения будет инвайтинг - из групповых чатоы ваших конкурентов/вашей тематики собираются пользователи и затем приглашаются в ваш чат. После приглашения пользователь сразу обнаруживает себя учасником вашего чата!",
          },
        ],
      },
      {
        title:
          "Какие показатели помогают понять, что канал эффективен для рекламы?",
        text: "",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Аудиторный рост",
            text: "Если у канала постепенно прибавляется количество читателей, значит контент регулярно обновляется и интересен. Если же произошел резкий «спад» - значит читателей накручивали.",
          },
          {
            title: "Вовлеченность пользователей",
            text: "Сравнивать нужно общее число подписчиков и число просмотревших посты. Чем меньше разница между этими числами, тем выше вовлеченность.",
          },
          {
            title: "Характер рекламы",
            text: "Как правило, размещаемые посты исчезают через 48 часов, но отследить их можно в Tgstat. Сервис-каталог сохраняет все публикации, даже удаленные. Если канал публикует разношерстный контент или информацию непристойного содержания – к вашей рекламе отнесутся с подозрением.",
          },
        ],
      },
    ],
  },
  {
    id: 2,
    img: "rocket",
    backgroundColor: "#8899cfb0",
    link: "how-to-telegram-channel",
    title: "Как вести канал в Telegram",
    anotation:
      "В этой статье разберемся, как грамотно внедрять инструменты продвижения, наладить здоровый контакт с аудиторией, а также создавать уникальный контент внутри своего канала Telegram",
    caption:
      "Telegram-каналы – один из самых популярных инструментов продвижения собственного бренда в настоящее время. Как всем известно – это не просто мессенджер, а мощная площадка для обмена контентом и пользовательского взаимодействия. На сегодняшний день русскоязычный сегмент содержит более 300 000 крупных и мелких каналов. Кстати, общая аудитория Telegram составляет уже 50 миллионов человек! Как же вести Телеграм-канал?\n\nВ этой статье разберемся, как грамотно внедрять инструменты продвижения, наладить здоровый контакт с аудиторией, а также создавать уникальный контент внутри своего канала Telegram.",
    footer:
      "Безусловно, статистические данные необходимо отслеживать, чтобы понимать вовлеченность аудитории и повышать эффективность контента. Надеемся мы смогли рассказать вам что-то новое о ведении канала. Как всегда ваша команда сервиса Pavel&Co. Успехов в продвижении!",
    sections: [
      {
        title: "Что публиковать в Telegram?",
        text: "Создавать инфоповоды на канале нужно продуманно и осознанно. Изначально, необходимо определиться с целью создания Telegram и публикации постов. Намерения могут быть абсолютно разные. По целевому назначению каналы разделяют на личные и корпоративные. Первые продвигают бренд/продукт и помогают заработать на рекламе. Последние предназначены для продвижения компании, завоевания признания аудитории и создания трафика.\n\nНе стоит забывать и о востребованных тематиках. До 80% аудитории обращают внимание на новостные каналы, так как быть «в курсе» событий как никогда важно в современном мире. Развлекательные сообщества собирают до 64% аудитории – расслабляющий контент также востребован. Образовательные каналы занимают 58% пользователей. И, наконец, 48% аудитории интересуются отраслевыми новостями выбранной индустрии.\n\nЧтобы контент-план всегда был «наполнен» идеями и расписан на месяцы вперед, вы должны быть знатоком и фанатом своей темы. Телеграм-каналы требуют регулярного обновления и «подогрева» информации. Если ваша тема будет актуальна и востребована, если она будет поводом для обсуждения подписчиков – успех гарантирован!\n\nПосле того, как выбрана тематика канала, необходимо провести анализ конкурентов. Мониторинг стиля подачи информации, инструментов продвижения коллег позволит понять, что уникального вы сможете предложить пользователям в выбранном сегменте. Искать каналы-конкуренты легче всего по ключевым словам через основную панель поиска. Первыми, как правило, будут показаны наиболее востребованные страницы в выбранной тематике.\n\nЭффективность и успешность постов определяется уровнем вовлеченности аудитории. Чтобы определить данный показатель, нужно разделить количество просмотров у какого-либо поста на количество подписчиков. Чем выше полученный процент – тем эффективней работают инструменты продвижения.\n\nСуществуют следующие форматы публикаци:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Ссылка с подводкой",
            text: "Самый популярный и частый тип подачи информации. Как результат – повышение трафика на необходимые страницы. Когда подводка слишком длинная, ссылку вставляют и в начале, и в конце.",
          },
          {
            title: "Текстовое сообщение",
            text: "Грамотный текст всегда привлекает внимание. Интересные и правильно сформулированные мысли, разделенные на абзацы, вовлекают большое количество человек. Тексты можно дополнить хештегами по вашей теме, которые будут выступать «маркерами» для подписчиков.",
          },
          {
            title: "Картинка с короткой подписью",
            text: "Такие посты привлекают тем, что не требуют большого времени для прочтения – пользователь не откладывает их, а сразу оценивает.",
          },
          {
            title: "Подборка",
            text: "Такой вариант поста актуален для рекламных кампаний, составления ТОП-листов и дайджестов по выбранной теме. Довольно часто администраторы выбирают отдельный день на неделе, в который публикуется та или иная подборка. Подписчики привыкают и еженедельно ожидают полезной информации в ваших постах.",
          },
          {
            title: "Опросы",
            text: "Данный вид постов выступает важнейшим инструментом вовлечения аудитории. Опросы проводятся для того, чтобы узнать мнение читателей. В настройках можно настроить один или несколько вариантов ответа, режим «викторины». Во время таких опросов владелец канала может оценить вовлеченность аудитории.",
          },
        ],
      },
      {
        title: "Как должны выглядеть Telegram-посты?",
        text: "Контент на каналах может оформляться разными способами в зависимости от тематики и типа сообщения. Внутри мессенджера существуют настройки оформления текста: полужирный и жирный шрифты, возможность добавить гиперссылки. Для того, чтобы отформатировать сообщение, необходимо нажать на раздел «форматирование» и выбрать нужные характеристики.\n\nСуществуют «горячи» клавиши для оперативного форматирования текста:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "",
            text: "CTRL + B = полужирный",
          },
          {
            title: "",
            text: "CTRL + I = курсив",
          },
          {
            title: "",
            text: "CTRL + U = подчеркнутый",
          },
          {
            title: "",
            text: "CTRL + SHIFT + X = зачеркнутый",
          },
          {
            title: "",
            text: "CTRL + SHIFT + M = моноширинный текст",
          },
          {
            title: "",
            text: "CTRL + K = добавление гиперссылки в выбранном участке текста",
          },
        ],
      },
      {
        title: "Составляем контент-план для Телеграм-канала",
        text: "Составление контент-плана – важное мероприятие для эффективного существования страницы в Telegram. Он состоит из расписанных тем постов с датой и времени публикации. Контент-планы составляются на неделю, месяц, квартал или год. С намеченной «сеткой» публикаций можно чувствовать себя уверенно и точно знать, что не наступит так называемого «творческого ступора».\n\nЧтобы составить качественный контент-план, необходимо соблюдать несколько незамысловатых правил. Первое и самое важное – записывать все свои мысли, «ловить» идеи и фиксировать. Второе – распределять посты по тематике и назначению на продающие, информационные, развлекательные и другие. Важно, чтобы канал сочетал разные типы постов. Таким образом читатели не устают от однообразного «нагроможденного» контента и дольше остаются на странице вашего канала.\n\nКонтент-план – сугубо индивидуален под каждый проект. Важно ориентироваться на аудиторные группы и предпочтения ваших читателей. Как правило, большинство каналов на сегодняшний день публикуют чуть меньше 10 публикаций в неделю.\n\nЗачем необходимо контент-планирование?",
        withImage: false,
        withList: true,
        list: [
          {
            title: "",
            text: "Помогает оставаться пунктуальным для своих подписчиков в плане публикации контента.",
          },
          {
            title: "",
            text: "Позволяет посмотреть на предлагаемую читателям информацию со стороны, внедрять различные форматы и рубрики, разнообразить контент.",
          },
        ],
      },
      {
        title: "Автоматизация Telegram-канала",
        text: "Зачем это нужно? Чтобы облегчить работу владельца и освободить время для «творческого штурма». Автоматизация с помощью ботов и внешних сервисов помогает с автопостингом контента. Также перечисленные инструменты можно использовать как инструмент продвижения личного бренда или продукта. К примеру:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "",
            text: "Накрутка ботов в канал.",
          },
          {
            title: "",
            text: "Накрутка просмотров на посты.",
          },
          {
            title: "",
            text: "Рассылка в групповые чаты или личные сообщения.",
          },
          {
            title: "",
            text: "Автоматизированные чат-боты.",
          },
        ],
      },
      {
        title: "Боты: принципы работы и предназначение",
        text: "Главными помощниками в работе администратора являются боты. Мессенджер предлагает обширный список представителей по различным тематикам.\n\nНачать управление каналом следует с бота @ControllerBot. С его помощью можно публиковать посты, добавлять эмодзи и гиперссылки, просматривать статистику просмотров. Чтобы внедрить этого бота, нужно создать собственного с помощью @BotFather, а затем добавить его в администраторы вашего канала. Далее – в боте @ControllerBot нажать на функцию «addchannel». Кстати, с помощью этого же бота можно добавлять «комментарии» на публикации для общения подписчиков.\n\nНа просторах мессенджера существует множество таким чат-ботов для различных целей. Среди них есть и для создания иллюстраций – @coub и @gif. Если необходимо провести розыгрыш – в этом поможет @VoterBiBot. Бот помогает в проведении автоматизированных розыгрышей путем рандомного выбора пользователя.",
        withImage: false,
        withList: false,
      },
      {
        title: "Автоматизация телеграм-канала через внешние сервисы",
        text: "Если для вашего проекта не подходят боты, можно привлекать сторонние сервисы для управления сообществом в мессенджере. Специальные программы позволяют контролировать аккаунты во всех социальных сетях на одной площадке. Удобно и практично!\n\nСреди популярных сервисов выделяют следующие:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "SMMplanner",
            text: "Удобная площадка, которая позволяет взаимодействовать с аккаунтами в Instagram и Pinterest, Viber и VK, OK и Facebook, Twitter. В месяц можно планировать до 100 публикаций совершенно бесплатно. Сервис удобен для автоматизации постов и просмотра минимальной статистики.",
          },
          {
            title: "Kuku.io",
            text: "Платная площадка для управления социальными сетями. За символическую сумму от 7 долларов можно создавать индивидуальное расписание публикаций, опросы для аудитории, gif-файлы, гиперссылки. Аналитика аккаунтов также включена в подписку.",
          },
          {
            title: "Amplifr",
            text: "Сервис Amplifr позволяет контролировать до 5 аккаунтов в различных социальных сетях с неограниченным количеством публикаций. В подписку включен встроенный сервис Canva для обработки фотографий и создания инфографики, метки utm и расширенная аналитика.",
          },
          {
            title: "Assistant.im",
            text: "бесплатная площадка для автоматизации Telegram-канала. Можно создавать контент-планы, опросы, сокращать ссылки, адаптировать различные типы медиа файлов. Аналитика сервиса предполагает не только мониторинг вовлеченности, но и отслеживание геолокации.",
          },
        ],
      },

      {
        title: "Аналитика на канал: как отследить?",
        text: "Telegram предлагает владельцам сообществ встроенный анализ аудитории. Правда доступна эта функция только для каналов с подписчиками более 1000. Вкладка со статистикой располагается в «описании» канала.\n\nДанные предлагаются в виде наглядной инфографики:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "",
            text: "Общие данные по количеству подписчиков на данный момент. Прирост, пользователи с активными уведомлениями на публикации, данные по пересылке постов.",
          },
          {
            title: "",
            text: "Динамика просмотров контента.",
          },
          {
            title: "",
            text: "Графики по источникам: один для подписчиков, другой для просмотров. Эта статистика поможет в рекламе канала, когда необходим мониторинг различных маркетинговых площадок.",
          },
        ],
      },
    ],
  },
  {
    id: 3,
    img: "discussion",
    backgroundColor: "#cf88b3b2",
    link: "group-channel-difference",
    title: "Чем отличается канал от группы в Telegram?",
    anotation: "Разбираем особую специфику группового общения в Telegram",
    caption:
      "На сегодняшний день интернет-общение с аудиторией в мессенджерах набирает все большую популярность. Группы и каналы в сети Телеграм – не только популярные, но еще и самые действенные способы для взаимодействия пользователей и продвижения собственного бренда/продукта. Но как же определить, что именно создавать? В чем их различия, преимущества/недостатки? Разбираемся в особой специфике группового общения в Telegram.",
    footer:
      "Данная статья должна была разветь любые соинения по поводу является ли тот или иной ресурс каналом или групповым чатом, но если у вас остались какие-то вопросы, то мы всегда будем рады на них ответить ;) Успехов в продвижении!",
    sections: [
      {
        title: "Что такое Telegram-канал?",
        text: "Создание канала в Telegram – это лучший способ дистрибуции вашего контента. По своим функциями они напоминают сообщества Вконтакте или личные блоги. С их помощью можно размещать информационные или развлекательные сообщения, различные инструкции, новости для целевой аудитории. Также Telegram-каналы – мощная площадка для развития пользовательского контента. Ваши сообщения ожидают пользователя, а не теряются в общей ленте новостей – вот главное преимущество этой социальной сети.\n\nОсобенности каналов в Telegram:",
        withImage: false,
        withList: true,
        list: [
          {
            title: "Неограниченное число участников.",
            text: "Каналы могут содержать абсолютное кол-во участников. Sky is the limit, как говориться ;)",
          },
          {
            title: "Односторонняя коммуникация",
            text: "Создание публикаций доступно только владельцу/администратору. Участники могут только читать сообщения. Возможно также ставить «реакции» и оставлять комментарии (если это разрешит владелец).",
          },
          {
            title: "Скрытые для пользователей участники",
            text: "Пользователи могут взаимодействовать между собой только посредством обсуждений под отдельными постами и могут видят только общее число подписчиков, а не отдельные профили.",
          },
        ],
      },
      {
        title: "Что такое группа в Telegram?",
        text: "Комьюнити аналогичны коллективным чатам в других известных мессенджерах. Данные объединения созданы прежде всего для многоканальной коммуникации участников: обмена мнениями, сбора информации, онлайн-поддержки, доступа к частной информации, объединения аудитории крупных сообществ.\n\nЧаты объединяют сторонников бренда/компании и формируют следующие цепочки связей по типу: «бизнес – клиенты», «сервис – пользователи», «медиа – читатели». В группе люди активно взаимодействуют между собой, обмениваются текстовыми сообщениями и медиа-файлами, участвуют в обсуждении инфоповодов.",
        withImage: false,
        withList: false,
      },
      {
        title: "Классификация сообществ в Telegram",
        text: "Данные способы общения в мессенджере подразделяются на Публичные (общедоступные) и Частные (приватные). Чтобы стать участников частного комьюнити, необходимо пройти по ссылке-приглашению. Также владелец канала может добавлять подписчиков из своего списка контактов. Найти общедоступные каналы возможно через поисковую систему Telegram, в отличие от приватных. Способ привлечения аудитории с помощью ссылки, или инвайтинг, доступен только для групповых чатов.",
        withImage: false,
        withList: false,
      },
      {
        title: "7 важных различий групп и каналов",
        text: "",
        withImage: false,
        withList: true,
        list: [
          {
            title: "1. Функционал владельца",
            text: "Публиковать сообщения на канале может исключительно владелец/администратор. В формате односторонней коммуникации выполняются информационная функция: контент публикуется – подписчики читают.\n\nВ группе владелец выступает в свою очередь также модератором контента. Он должен управлять сообщениями, следить за спамом и нарушениями. Владелец группы следит за сохранением ton of voice в пределах данного сообщества.",
          },
          {
            title: "2. Доступность профилей",
            text: "Здесь все просто: когда вы подписчик канала, то вам недоступны профили других участников (исключение - наличие обсуждений под постами), даже если они из списка ваших контактов. Чаты же позволяют заходить на личные «страницы» других пользователей и взаимодействовать с ними.",
          },
          {
            title: "3. Инструменты продвижения",
            text: "В Telegram-каналах осуществляется накрутка просмотров. Уникальная особенность  групповых чатов - инвайтинг, то есть частные приглашения в закрытое объединение. Повышают вовлеченность аудитории также боты и рассылки, которые можно внедрять в оба типа сообществ.",
          },
          {
            title: "4. Доступность контента",
            text: "Новый подписчик Телеграм-канала может видеть историю сообщений с момента создания. В случае с группой, администратор может определить, смогут ли новоприбывшие единомышленники видеть прежние сообщения, либо ограничить доступ к истории чатов.",
          },
          {
            title: "5. Статистика",
            text: "Отслеживать статистику в Telegram-канале значительно проще, чем в группе. Рядом с каждым постом указано число просмотревших его подписчиков. Также отслеживать активность аудитории на канале можно через «реакции» и комментарии, разрешив их в настройках сообщества.\n\nВовлеченность группы определяется исключительно по числу человек и активности чата.",
          },
          {
            title: "6. Уведомления о постах/сообщениях",
            text: "Как и пабликах Вконтакте, подписчики никак не информируются о том, что к сообществу присоединился новый пользователей. Это прерогатива исключительно администратора. Однако владельцы каналов могут доставлять своим подписчикам бесшумные уведомления. Чтобы активировать данную функцию, необходимо нажать на «колокольчик» рядом с полем поста.\n\n Telegram-группах все участники оповещаются о присоединении нового пользователя. Однако можно отключить данную функцию с помощью внедрения ботов, например, @joinhider_bot.",
          },
          {
            title: "7. Обратная связь",
            text: "В большинстве случаев Telegram-каналы – это площадка с односторонней коммуникацией. Однако владелец может добавить «реакции» и комментарии, исходя из которых сможет получать обратную связь от подписчиков.\n\nруппы же располагают к обмену мнениями и созданием пользовательского «поля обсуждения». Администраторы с легкостью получают «живую» обратную связь.",
          },
        ],
      },
    ],
  },
];
